import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import SlackFirstStep from 'components/pages/settings/notifications/collaborationApps/SlackFirstStep'
import SlackSecondStep from 'components/pages/settings/notifications/collaborationApps/SlackSecondStep'
import SlackThirdStep from 'components/pages/settings/notifications/collaborationApps/SlackThirdStep'
import TeamsFirstStep from 'components/pages/settings/notifications/collaborationApps/TeamsFirstStep'
import TeamsFourthStep from 'components/pages/settings/notifications/collaborationApps/TeamsFourthStep'
import TeamsSecondStep from 'components/pages/settings/notifications/collaborationApps/TeamsSecondStep'
import TeamsThirdStep from 'components/pages/settings/notifications/collaborationApps/TeamsThirdStep'

import {
  CANCEL_INTEGRATION_REQUEST,
  CHANGE_WIZARD_INDEX,
  FETCH_SLACK_DATA_REQUEST,
  FETCH_TEAMS_DATA_REQUEST,
  SELECT_APP,
  SLACK_CONST,
  UPDATE_COLLABORATION_APP_ALERTS_REQUEST,
  UPDATE_NOTIFICATIONS_REQUEST,
  UPDATE_WEBHOOK_URL,
} from './constants'

const slackFirstStep = {
  index: 1,
  Component: SlackFirstStep,
}

const slackSecondStep = {
  index: 2,
  Component: SlackSecondStep,
}

const slackThirdStep = {
  index: 3,
  Component: SlackThirdStep,
}

const teamsFirstStep = {
  index: 1,
  Component: TeamsFirstStep,
}

const teamsSecondStep = {
  index: 2,
  Component: TeamsSecondStep,
}

const teamsThirdStep = {
  index: 3,
  Component: TeamsThirdStep,
}

const teamsFourthStep = {
  index: 4,
  Component: TeamsFourthStep,
}

const slackSteps = [slackFirstStep, slackSecondStep, slackThirdStep]

const teamsSteps = [teamsFirstStep, teamsSecondStep, teamsThirdStep, teamsFourthStep]

export const getStepComponent = (array, index) =>
  array.find((step) => step.index === index).Component

export default function () {
  const initialState = {
    data: {
      slack: {},
      teams: {},
      loader: false,
      error: null,
    },
    loader: false,
    error: null,
    steps: [],
    chosenIntegration: null,
    webhookUrl: null,
    wizardIndex: 0,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case SELECT_APP:
        return {
          ...state,
          steps: action.payload.appValue === SLACK_CONST ? slackSteps : teamsSteps,
          chosenIntegration: action.payload.appValue,
          error: null,
          webhookUrl: null,
        }
      case UPDATE_WEBHOOK_URL:
        return { ...state, webhookUrl: action.payload.val }
      case CHANGE_WIZARD_INDEX:
        return { ...state, wizardIndex: action.payload.wizardIndex }
      case COMPANY_FILTER_CHANGE:
        return {
          ...state,
          loader: true,
          error: null,
          wizardIndex: 0,
        }
      case FETCH_SLACK_DATA_REQUEST.INITIATE:
      case FETCH_TEAMS_DATA_REQUEST.INITIATE:
      case UPDATE_NOTIFICATIONS_REQUEST.INITIATE:
      case CANCEL_INTEGRATION_REQUEST.INITIATE:
        return { ...state, loader: true }
      case FETCH_SLACK_DATA_REQUEST.SUCCESS:
        return {
          ...state,
          error: null,
          data: {
            ...state.data,
            slack: action.payload.data,
          },
          webhookUrl: action.payload.data?.webhookUrl || null,
          loader: false,
        }
      case FETCH_TEAMS_DATA_REQUEST.SUCCESS:
        return {
          ...state,
          error: null,
          data: {
            ...state.data,
            teams: action.payload.data,
          },
          webhookUrl: action.payload.data?.webhookUrl || null,
          loader: false,
        }
      case UPDATE_NOTIFICATIONS_REQUEST.SUCCESS:
        return {
          ...state,
          error: null,
          loader: false,
          wizardIndex: 0,
        }
      case CANCEL_INTEGRATION_REQUEST.SUCCESS:
        return {
          ...state,
          error: null,
          loader: false,
          wizardIndex: 0,
        }
      case FETCH_SLACK_DATA_REQUEST.ERROR:
      case FETCH_TEAMS_DATA_REQUEST.ERROR:
      case CANCEL_INTEGRATION_REQUEST.ERROR:
        return { ...state, error: action.error, loader: false }
      case UPDATE_NOTIFICATIONS_REQUEST.ERROR:
        return {
          ...state,
          error: action.error,
          loader: false,
          webhookUrl: null,
        }
      case FETCH_SLACK_DATA_REQUEST.CANCEL:
      case FETCH_TEAMS_DATA_REQUEST.CANCEL:
        return { ...state, loader: false }
      case UPDATE_COLLABORATION_APP_ALERTS_REQUEST.INITIATE:
        return {
          ...state,
          data: {
            ...state.data,
            loader: true,
          },
        }
      case UPDATE_COLLABORATION_APP_ALERTS_REQUEST.SUCCESS:
        return {
          ...state,
          data: {
            ...state.data,
            loader: false,
          },
        }
      case UPDATE_COLLABORATION_APP_ALERTS_REQUEST.ERROR:
        return {
          ...state,
          data: {
            ...state.data,
            updateLoader: false,
            updateError: action.error.detail,
          },
        }
      default:
        return state
    }
  }
}
